import { defineMessage } from 'services/localization';

export const messages = {
    header: defineMessage('sales_settings_2'),
    defaultAccount: defineMessage('default_account'),
    trackingOption: defineMessage('tracking_option_index'),
};
